import { render } from "./calendar.vue?vue&type=template&id=7f09e96b"
const script = {}
script.render = render

export default script